import React from 'react';
import { SectionHelper } from '@wix/design-system';
import { t } from '../../../../../essentials/i18n';
import { TRANSLATIONS } from '../../../constants/translations';
import { AUTOMATION_IDS } from '../../../constants/automationIds';

export type BusinessAppOnOtherBranchesNotificationProps = {
  appId: string;
  appName: string;
  onAddApp: () => void;
};
const {
  ADD_APP_ON_OTHER_BRANCHES_TITLE,
  ADD_APP_ON_OTHER_BRANCHES_BODY,
  ADD_APP_ON_OTHER_BRANCHES_BUTTON,
} = TRANSLATIONS.MY_BUSINESS.BRANCHES;

export const BusinessAppOnOtherBranchesNotification: React.FC<
  BusinessAppOnOtherBranchesNotificationProps
> = ({ appName, onAddApp }) => {
  const title = t(ADD_APP_ON_OTHER_BRANCHES_TITLE, { appName });
  const actionText = t(ADD_APP_ON_OTHER_BRANCHES_BUTTON);
  const content = t(ADD_APP_ON_OTHER_BRANCHES_BODY, { appName });
  return (
    <SectionHelper
      dataHook={AUTOMATION_IDS.MY_BUSINESS.APP_ON_OTHER_BRANCHES_NOTIFICATION}
      title={title}
      actionText={actionText}
      border="topBottom"
      onAction={() => onAddApp()}
    >
      {content}
    </SectionHelper>
  );
};
